document.addEventListener('DOMContentLoaded', function () {
  /* ----------------------------------------
   * Scroll-in reveal
   * ---------------------------------------- */
  var bestsellersSections = document.querySelectorAll('.bestsellers');

  bestsellersSections.forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });

  /* ----------------------------------------
   * Helpers: quick add UI state
   * ---------------------------------------- */
  function setQuickAddState(card, isAvailable) {
    var quickAdd = card.querySelector('.bestseller-card__quick-add');
    if (!quickAdd) return;

    var tip = quickAdd.querySelector('.bestseller-card__quick-add-tooltip');

    if (isAvailable) {
      quickAdd.classList.remove('is-sold-out');
      quickAdd.removeAttribute('aria-disabled');
      quickAdd.removeAttribute('tabindex');

      var badge = quickAdd.querySelector('.quick-add-plus');
      if (badge) badge.textContent = '+';

      if (tip) tip.hidden = false;
    } else {
      quickAdd.classList.add('is-sold-out');
      quickAdd.setAttribute('aria-disabled', 'true');
      quickAdd.setAttribute('tabindex', '-1');

      var badge2 = quickAdd.querySelector('.quick-add-plus');
      if (badge2) badge2.textContent = '×';

      if (tip) tip.hidden = true;
    }
  }

  function getHandleFromProductUrl(url) {
    if (!url) return '';
    var parts = url.split('/products/');
    if (parts.length < 2) return '';
    var handle = parts[1];
    if (!handle) return '';
    return handle.split('?')[0].split('#')[0];
  }

  /* ----------------------------------------
   * Card hover + colour swatches + Quick add
   * ---------------------------------------- */
  var cards = document.querySelectorAll('.bestseller-card');

  cards.forEach(function (card) {
    var frame = card.querySelector('.bestseller-card__frame');
    var primaryImg = card.querySelector('.js-bestseller-image');
    var swatchButtons = card.querySelectorAll('.bestseller-card__swatch-button');
    var quickAdd = card.querySelector('.bestseller-card__quick-add');

    // Default variant id (first variant)
    var defaultVariantId = card.getAttribute('data-default-variant-id');

    // Default image src
    var defaultSrc = null;
    if (primaryImg) {
      defaultSrc =
        primaryImg.getAttribute('data-default-image') || primaryImg.getAttribute('src');
    }

    /* ----------------------------------------
     * Disable OOS swatches (based on data-variant-available)
     * + Set default active swatch (first available)
     * ---------------------------------------- */
    var defaultActiveBtn = null;

    swatchButtons.forEach(function (btn) {
      var availableAttr = btn.getAttribute('data-variant-available');
      var isAvailable = availableAttr === 'true';

      if (!isAvailable) {
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '-1');
      } else {
        btn.classList.remove('is-disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('tabindex');

        // pick first available as default active
        if (!defaultActiveBtn) defaultActiveBtn = btn;
      }
    });

    // Apply default active ring
    if (defaultActiveBtn) {
      defaultActiveBtn.classList.add('is-active');
    }

    // Flash only when hovering the IMAGE FRAME (and secondary image exists)
    if (frame && primaryImg) {
      var hasSecondaryImage = !!card.querySelector('.bestseller-card__image.is-secondary');
      
      frame.addEventListener('mouseenter', function () {
        if (hasSecondaryImage) {
          card.classList.add('is-flashing');
        }
      });

      frame.addEventListener('mouseleave', function () {
        card.classList.remove('is-flashing');

        // Reset primary image
        if (defaultSrc) primaryImg.setAttribute('src', defaultSrc);

        // Reset active preview back to default (so ring persists)
        swatchButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        if (defaultActiveBtn) defaultActiveBtn.classList.add('is-active');
      });
    }

    // Swatch hover + click
    swatchButtons.forEach(function (button) {
      button.addEventListener('mouseenter', function () {
        // If disabled, do nothing
        if (button.classList.contains('is-disabled')) return;
        if (!primaryImg) return;
        // Locked-away swatches on exploded tiles have no data-color-name;
        // skip hover effects for them (click-only, keeps the tile's own ring active).
        if (!button.getAttribute('data-color-name')) return;

        var variantImg = button.getAttribute('data-variant-image');

        if (variantImg) {
          primaryImg.setAttribute('src', variantImg);
        } else if (defaultSrc) {
          primaryImg.setAttribute('src', defaultSrc);
        }

        swatchButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        button.classList.add('is-active');

        card.classList.remove('is-flashing');

        // Sync size overlay with swatch colour
        var swatchColor = button.getAttribute('data-color-name');
        if (swatchColor && card._sizeOverlayUpdate) {
          card._sizeOverlayUpdate(swatchColor);
        }
      });

      // Click swatch → go to variant URL
      button.addEventListener('click', function () {
        if (button.classList.contains('is-disabled')) return;

        var variantUrl = button.getAttribute('data-variant-url');
        if (variantUrl) {
          window.location.href = variantUrl;
          return;
        }

        var productUrl = card.getAttribute('data-product-url');
        if (productUrl) window.location.href = productUrl;
      });
    });

    // ── Size overlay logic ──
    var sizeOverlay = card.querySelector('.bestseller-card__size-overlay');
    if (sizeOverlay) {
      var overlayDataEl = card.querySelector('[data-size-overlay-data]');
      var overlayData = null;
      if (overlayDataEl) {
        try { overlayData = JSON.parse(overlayDataEl.textContent); } catch (e) {}
      }

      var sizePills = sizeOverlay.querySelectorAll('.size-pill');
      var productUrl = card.getAttribute('data-product-url') || '';
      var colourLabel = sizeOverlay.querySelector('[data-overlay-colour-label]');
      var prevArrow = sizeOverlay.querySelector('.size-overlay__arrow--prev');
      var nextArrow = sizeOverlay.querySelector('.size-overlay__arrow--next');

      var overlayColours = [];
      swatchButtons.forEach(function (btn) {
        if (!btn.classList.contains('is-disabled')) {
          var name = btn.getAttribute('data-color-name') || '';
          var img = btn.getAttribute('data-variant-image') || '';
          if (name) overlayColours.push({ name: name, image: img });
        }
      });

      var defaultColorName = defaultActiveBtn ? (defaultActiveBtn.getAttribute('data-color-name') || '') : '';
      var overlayColorIndex = 0;

      var secondaryIndex = 0;
      if (overlayColours.length > 1) {
        for (var si = 0; si < overlayColours.length; si++) {
          if (overlayColours[si].name !== defaultColorName) {
            secondaryIndex = si;
            break;
          }
        }
      }

      function updateSizePills(colorName) {
        if (!overlayData || !colorName) return;
        var colorData = overlayData[colorName];
        if (!colorData) return;
        sizePills.forEach(function (pill) {
          var sizeVal = pill.getAttribute('data-size-value');
          var info = colorData[sizeVal];
          if (info) {
            pill.classList.toggle('size-pill--oos', !info.available);
            if (info.variantId) pill.href = productUrl + '?variant=' + info.variantId;
          }
        });
      }

      function setOverlayColour(index) {
        if (!overlayColours.length) return;
        overlayColorIndex = ((index % overlayColours.length) + overlayColours.length) % overlayColours.length;
        var colour = overlayColours[overlayColorIndex];
        if (colourLabel) colourLabel.textContent = colour.name;
        updateSizePills(colour.name);
        if (primaryImg && colour.image) {
          primaryImg.setAttribute('src', colour.image);
          card.classList.remove('is-flashing');
        }
        swatchButtons.forEach(function (btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-color-name') === colour.name);
        });
      }

      if (prevArrow) {
        prevArrow.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          setOverlayColour(overlayColorIndex - 1);
        });
      }
      if (nextArrow) {
        nextArrow.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          setOverlayColour(overlayColorIndex + 1);
        });
      }

      if (frame) {
        // NOTE: the previous mouseenter handler here called setOverlayColour,
        // which reset primary.src and removed is-flashing on the same event —
        // killing the hover flash. It also auto-cycled to a secondary colour,
        // which is wrong now that exploded tiles are locked to one colour.
        // Arrow clicks still drive explicit colour switching via setOverlayColour.

        frame.addEventListener('mouseleave', function () {
          if (defaultColorName) {
            for (var di = 0; di < overlayColours.length; di++) {
              if (overlayColours[di].name === defaultColorName) {
                overlayColorIndex = di;
                break;
              }
            }
          }
        });
      }

      sizePills.forEach(function (pill) {
        pill.addEventListener('click', function (e) { e.stopPropagation(); });
      });

      card._sizeOverlayUpdate = function (colorName) {
        for (var ui = 0; ui < overlayColours.length; ui++) {
          if (overlayColours[ui].name === colorName) { overlayColorIndex = ui; break; }
        }
        if (colourLabel) colourLabel.textContent = colorName;
        updateSizePills(colorName);
      };

      if (!defaultColorName && overlayData) {
        var firstColor = Object.keys(overlayData)[0];
        if (firstColor) updateSizePills(firstColor);
      } else if (defaultColorName && overlayData) {
        updateSizePills(defaultColorName);
      }
    }

    // Quick add click (SINGLE source of truth)
    if (quickAdd) {
      quickAdd.addEventListener('click', function (e) {
        var isSoldOut =
          quickAdd.classList.contains('is-sold-out') ||
          quickAdd.getAttribute('aria-disabled') === 'true';

        if (isSoldOut) return;

        var productUrl = card.getAttribute('data-product-url') || '';
        var handle = getHandleFromProductUrl(productUrl);

        // Liquid flag (if it exists)
        var requiresSelection = card.getAttribute('data-requires-selection') === 'true';

        // ✅ More reliable: if there are swatches, there are variants/choices
        var hasSwatches = !!card.querySelector('.bestseller-card__swatches');

        // ✅ When QuickView is available, open it for anything that looks "selectable"
        // (shoes, colours, multi-variant products)
        var canQuickView = window.QuickView && typeof window.QuickView.open === 'function';
        var shouldOpenQuickView = canQuickView && handle && (requiresSelection || hasSwatches);

        if (shouldOpenQuickView) {
          e.preventDefault();
          window.QuickView.open(handle);
          return;
        }

        // If it's a selectable product but QuickView isn't available, go to PDP
        if ((requiresSelection || hasSwatches) && productUrl) {
          // allow default navigation OR force it:
          // (forcing ensures no weird double-handlers)
          e.preventDefault();
          window.location.href = productUrl;
          return;
        }

        // Non-selectable: ajax add (if CartAPI exists), otherwise allow default navigation
        if (!(window.CartAPI && typeof window.CartAPI.addToCart === 'function')) {
          return;
        }

        e.preventDefault();

        var variantIdToAdd = defaultVariantId;
        if (!variantIdToAdd) return;

        quickAdd.setAttribute('aria-busy', 'true');

        window.CartAPI
          .addToCart({
            items: [{ id: Number(variantIdToAdd), quantity: 1 }]
          })
          .catch(function () {
            var url = card.getAttribute('data-product-url');
            if (url) window.location.href = url;
          })
          .finally(function () {
            quickAdd.removeAttribute('aria-busy');
          });
      });
    }
  });

  // Swap secondary images to show the next colour variant (matches collection behaviour)
  function swapSecondaryImages() {
    document.querySelectorAll('.bestseller-card').forEach(function (card) {
      if (card.hasAttribute('data-secondary-swapped')) return;
      var sec = card.querySelector('.bestseller-card__image.is-secondary');
      if (!sec) return;
      var active = card.querySelector('.bestseller-card__swatch-button.is-active');
      var btns = card.querySelectorAll('.bestseller-card__swatch-button');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i] === active) continue;
        if (btns[i].classList.contains('is-disabled')) continue;
        var src = btns[i].getAttribute('data-variant-image');
        if (src) {
          sec.removeAttribute('srcset');
          sec.src = src;
          card.setAttribute('data-secondary-swapped', 'true');
          break;
        }
      }
    });
  }

  swapSecondaryImages();
});
